import { Button, Group } from "@mantine/core";
import { IconBan, IconSend } from "@tabler/icons-react";

interface HeldEmailBulkButtonsProps {
  onRelease: () => void;
  onCancel: () => void;
}

export function HeldEmailBulkButtons({
  onRelease,
  onCancel,
}: HeldEmailBulkButtonsProps) {
  return (
    <Group>
      <Button leftSection={<IconSend size={16} />} onClick={onRelease}>
        Release
      </Button>
      <Button
        color="red"
        leftSection={<IconBan size={16} />}
        onClick={onCancel}
      >
        Cancel
      </Button>
    </Group>
  );
}
